import { ReactComponent as NewInBoostIcon } from "assets/New_in_boost_icon.svg";
import Typography from "components/common/Typography";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getUserHltId } from "utils/CommonFunctions";
import "./index.scss";
import { fetchBuzzCards, setReleaseHighlightDialog } from "./ReleaseHighlights.slice";

const ReleaseBanner = (props: any) => {
  const dispatch = useAppDispatch();

  const ReleaseHighlights = useAppSelector((state) => state.ReleaseHighlights);
  const { showBuzzSection } = ReleaseHighlights?.[getUserHltId()] || false;

  const onBuzzClick = async () => {
    await dispatch(fetchBuzzCards({ hltId: getUserHltId() }));
    dispatch(setReleaseHighlightDialog(true));
  };

  return showBuzzSection ? (
    <div className="banner-parent-container">
      <button className={`banner-container ${props.class}`} onClick={onBuzzClick}>
        <Typography color={tokens.Text.General.Secondary} showBold>
          BOOST Buzz{" "}
        </Typography>
        <div className="banner-container-icon">
          <Typography className="banner-container-icon-text" color={tokens.Text.General.PrimaryBody} variant={"body2"}>
            Click here to stay in the loop with what's new and noteworthy in BOOST
          </Typography>
          <NewInBoostIcon />
        </div>
      </button>
    </div>
  ) : (
    <></>
  );
};

export default ReleaseBanner;
